import {
  Badge,
  Td,
  Text,
  Tr,
  useClipboard,
  useColorMode,
} from "@chakra-ui/react";
import ChainInfo from "components/Chains/ChainInfo";
import RequestId from "components/Request/RequestId";
import { useState } from "react";

const BlockRow = ({ decodedBlockDetails, lastItem }) => {
  const {
    collectionId,
    collectionNameHash,
    power,
    requestId,
    result,
    requestingChainDomain,
    destinationChainDomain,
    requestType,
    message,
  } = decodedBlockDetails;

  const colorStatus = useColorMode("white", "gray.400");

  const [isCopied, setIsCopied] = useState(false);
  const { onCopy } = useClipboard(requestId);

  const handleCopy = () => {
    onCopy();
    setIsCopied(true);
    // Reset the copied state after a delay
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <Tr>
      <Td
        border={lastItem ? "none" : null}
        borderBottomColor="#56577A"
        ps="0px"
      >
        <Text fontSize="sm" color="#fff" fontWeight="bold">
          {requestId ? <RequestId requestId={requestId} isLink={true} /> : "-"}
        </Text>
      </Td>

      <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
        <Text fontSize="sm" color="#fff" fontWeight="bold">
          <ChainInfo chainId={requestingChainDomain} />
        </Text>
      </Td>

      <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
        <Text fontSize="sm" color="#fff" fontWeight="bold">
          <ChainInfo chainId={destinationChainDomain} />
        </Text>
      </Td>

      <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
        <Text fontSize="sm" color="#fff" fontWeight="bold">
          <Badge
            fontSize="sm"
            p="3px 10px"
            borderRadius="8px"
            fontWeight="bold"
          >
            {requestType || "-"}
          </Badge>
        </Text>
      </Td>

      <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
        <Text fontSize="sm" color="#fff" fontWeight="bold">
          {message || "-"}
        </Text>
      </Td>

      <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
        <Text fontSize="sm" color="#fff" fontWeight="bold">
          {result || "-"}
        </Text>
      </Td>
    </Tr>
  );
};

export default BlockRow;
